import React, { useContext, useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import messages from './DriverDetailsComponent.messages';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './DriverDetailsComponent.metadata.json5';
import DriverContactComponent from '../DriverContactComponent/DriverContactComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function DriverDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, authHeader } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('DriverDetailsComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    const [isEditContact, setIsEditContact] = useState(false);
    const [isAddNewContact, setIsAddNewContact] = useState(false)
    const [newContact, setNewContact] = useState({})

    const { showConfirm } = useModal();

    modelVM.value.isValidationReq = true;

     useEffect(() => {
        setIsEditContact(modelVM.namFiePublicId && modelVM.namFiePublicId.value !== undefined)
    }, []);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    ); 

    const handleNamFieValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.namFie.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const getAvailableDrivers = () => {
            const availableValues = submissionVM.value.lobData.perLine.coverables.perUmbLiaCoverable.allDrivers.map((driverObj) => ({
                code: driverObj.publicID,
                name: driverObj.displayName ? driverObj.displayName : driverObj.firstName + ' ' + driverObj.lastName
            }));

            var hadNew = availableValues && availableValues.length >0 ? availableValues.find((driverObj) => {
                return driverObj.code === 'new'
            }) : null;
    
            if(!hadNew) {
                availableValues.push({
                code: 'new',
                name: '-- Add New --'
             })
            } 
            return availableValues;
        };

        const onSaveContact = async () => {
            modelVM.namFiePublicId.value = modelVM.namFie.publicID.value
            submissionVM.value.lobData.perLine.coverables.perUmbLiaCoverable.allDrivers.push(modelVM.namFie.value)
            setIsAddNewContact(false);
            setIsEditContact(true);
        }

        const onCancelAddContactClick = async () => {
            setIsAddNewContact(false);
            setIsEditContact(true);
        }
    
       const setIsEditButton = () => {
            setIsEditContact(false)
            setIsAddNewContact(true);
        }

    
        const handleNameFieDropDown = (value, changedPath) => {

            if (value === 'new' && changedPath === 'namFiePublicId') {
                const model = {subtype: "Person", accountHolder :false, publicID: value, primaryAddress: {country: "CA",
                isFromPortal: true,} }
                const { _xCenter, _dtoName } = modelVM.namFie;
                const contactDetailsVM = viewModelService.create(model, _xCenter, "edgegen.capabilities.policyjob.lob.perproduct.coverables.dto.personalumbrella.DriverPersonDTO");
                _.set(modelVM, 'namFie.value', contactDetailsVM.value);
                setIsAddNewContact(true);
                setIsEditContact(false);
                modelVM.namFiePublicId.value = modelVM.namFie.publicID.value;
            } else {
                modelVM.namFie.value = _.find(submissionVM.value.lobData.perLine.coverables.perUmbLiaCoverable.allDrivers, (driverObj) => driverObj.publicID === value);
                modelVM.namFiePublicId.value = modelVM.namFie.publicID.value;
                setIsAddNewContact(false);
                setIsEditContact(true);
            }
            handleValueChange(value, changedPath);
            handleValueChange(modelVM.namFie.value, 'namFie');
        };

    const deleteDriverDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.perUmbLiaCoverable.driverDetails.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        namFiePublicId: {
            availableValues: getAvailableDrivers(),
            onValueChange: handleNameFieDropDown
        },
        driverButtonContainer: {
            visible: isEditContact
        },
        addNewContainer:{
            visible: isAddNewContact
        },
        addContact:{
            contactVM: modelVM.namFie,
            setComponentValidation: onValidate,
            viewModelService,
            onValueChange: handleNamFieValueChange
        },
        saveContactBtn:{
            visible: !!(isAddNewContact && modelVM),
            disabled: !(modelVM.namFie && modelVM.namFie.aspects.valid && modelVM.namFie.aspects.subtreeValid),
            onClick: onSaveContact
        },
        cancelAddContactBtn:{
            onClick: onCancelAddContactClick
        }, 
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteDriverDetails,
            setIsEditButton
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            driverContactComponent: DriverContactComponent
        }
    };


    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

DriverDetailsComponent.propTypes = wizardProps;
export default withRouter(DriverDetailsComponent);
